import React, { useState, useEffect, useRef } from 'react';

import InputRadio from 'app/components/common/InputRadio';

import classNames from 'classnames/bind';
import styles from './JoinFirmList.module.scss';

const cx = classNames.bind(styles);

function JoinFirmList({ dataList = [], value, onChangeTab, onChangeFirm }) {
	const dataMap = dataList.map((item, i) => {
		const key = `tab${i}`;
		return (
			<li
				className={cx('item')}
				key={key}
			>
				<InputRadio
					type="radio"
					id={key}
					name={key}
					label={item.name}
					value={item.value}
					target={value}
					index={0}
					onChange={onChangeFirm}
				/>
			</li>
		);
	});

	const [tabActive, setActive] = useState(0);
	const handleTab = (tabIndex, character) => {
		setActive(tabIndex);
		onChangeTab(tabIndex, character);
	};
	const tabList = ['전체', 'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
	const tabMap = tabList.map((item, i) => {
		const key = `tab${i}`;
		return (
			<li
				className={cx('item')}
				key={key}
			>
				<button
					type="button"
					className={cx('btn', { active: tabActive === i })}
					onClick={() => handleTab(i, item)}
				>
					{item}
				</button>
			</li>
		);
	});

	// 영역 높이 계산
	const [height, setHeight] = useState(0);
	const refArea = useRef(null);
	const onResize = () => {
		setHeight(document.body.clientHeight - refArea.current.offsetTop - 90);
	};
	useEffect(() => {
		onResize();
		window.addEventListener('resize', onResize);
		return () => window.removeEventListener('resize', onResize);
	}, []);

	return (
		<div
			className={cx('list_initial')}
			style={{ height }}
			ref={refArea}
		>
			<div className={cx('tab')}>
				<ul className={cx('list')}>{tabMap}</ul>
			</div>
			<div className={cx('data')}>
				{dataMap.length ? (
					<ul className={cx('list')}>{dataMap}</ul>
				) : (
					<p className={cx('none')}>
						상사 리스트를 준비중입니다. <br />
						오른쪽 상단에 있는 직접 입력을 이용해주세요.
					</p>
				)}
			</div>
		</div>
	);
}

export default JoinFirmList;
